// ── 출퇴근 관리 [달력] [직원별 상세] 스위치 (2026-09-29) ─────────────────────────────
//   사용자: "더 잘 보이게 배경 검정색 스위치 느낌으로, 크기 줄이기" — 바탕(틀) 검정 + 고른 쪽만 흰 칸.
//   검정은 주요 버튼과 같은 토큰(--std-btn: 밝은 모드 검정 / 어두운 모드 파랑) — 두 모드 모두 주요 버튼과 한 색.
//   자리: 윗부분 틀(AttendancePageHeader) 1줄 오른쪽, 메뉴(☰) 바로 왼쪽 — 두 탭에서 같은 자리.
//   글자 굵기는 고른 쪽·안 고른 쪽 같게(굵기가 다르면 스위치 폭이 바뀌어 오른쪽 끝이 흔들린다). 탭이 하나뿐이면 그리지 않는다.
import React from 'react';
import { TAB_LABELS } from './attendanceTabs';

const wrapStyle = {
  display: 'inline-flex', gap: 2, padding: 3,
  width: 'fit-content', alignSelf: 'center',
  background: 'var(--std-btn, #0f172a)', borderRadius: 10,
};

function tabStyle(active) {
  return {
    padding: '5px 12px', border: 0, borderRadius: 8, cursor: 'pointer',
    fontSize: 12, fontWeight: 700, lineHeight: 1.4,
    background: active ? '#ffffff' : 'transparent',
    color: active ? '#0f172a' : 'rgba(255, 255, 255, 0.72)',
  };
}

export default function AttendanceTabBar({ tabs, active, onChange }) {
  if (!Array.isArray(tabs) || tabs.length < 2) return null;
  return (
    <div role="tablist" aria-label="출퇴근 보기" className="no-print" style={wrapStyle}>
      {tabs.map((key) => (
        <button
          key={key}
          type="button"
          role="tab"
          aria-selected={active === key}
          style={tabStyle(active === key)}
          onClick={() => { if (active !== key) onChange(key); }}
        >
          {TAB_LABELS[key] || key}
        </button>
      ))}
    </div>
  );
}
